import { NUTRIENTS } from '../../../shared/constants/NUTRIENTS';
import { getRoundedNumber } from '../../../shared/utils/mathUtils';
import { FoodWithScore } from '../../interfaces/FoodScorePageResponse';

export const getFoodsWithRoundedNutrients = (foods: FoodWithScore[]): FoodWithScore[] => {
  return foods.map((food) => {
    const roundedNutrients = NUTRIENTS.reduce(
      (acc, nutrient) => {
        acc[nutrient] = getRoundedNumber(food[nutrient], 1);
        return acc;
      },
      {} as Pick<FoodWithScore, (typeof NUTRIENTS)[number]>,
    );

    return { ...food, ...roundedNutrients };
  });
};
